import React, { useEffect } from "react";
import clsx from "classnames";
import { Helmet } from "react-helmet";

import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import { Player, BigPlayButton, ControlBar, LoadingSpinner } from "video-react";
import "video-react/dist/video-react.css"; // or import scss

import Parallax from "components/Parallax";
import GridContainer from "components/GridContainer";
import GridItem from "components/GridItem";

import Clients from "./sections/Clients";
import Features from "./sections/Features";
import DataFlow from "./sections/DataFlow";
// import OurUsers from "./sections/OurUsers";
import Blogs from "./sections/Blogs";
// import FAQ from "./sections/FAQ";
import CallToAction from "components/CallToAction";

import { container } from "assets/jss/material-kit-pro-react.jsx";
import { appUrl, rootUrl } from "../../../config";

const pathMedia = `${appUrl}/media/optafloor`;

const useStyles = makeStyles(theme => ({
  container: {
    ...container,
    zIndex: "12",
    color: "#FFFFFF",
  },
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3",
  },
  parallax: {
    background: "#FFFFFF",
    display: "flex",
    alignItems: "center",
  },
  content: {
    [theme.breakpoints.down("sm")]: {
      margin: "1em 0",
    },
  },
  product: {
    fontWeight: "normal",
    marginBottom: "1.5rem",
  },
  subtitle: {
    margin: "1.5rem 0",
  },
  button: {
    letterSpacing: 1,
    color: "#FFFFFF",
    backgroundColor: "#1d9cd9",
    padding: "0.6rem 1rem",
    fontSize: 12,
    "&:hover,&:focus": {
      color: "white",
      backgroundColor: "#42bcee",
    },
    margin: "0.5em 0.5em 0.5em 0",
  },

  videoContainer: {
    borderRadius: 10,
    boxShadow: "8px 8px 16px 0px rgba(0, 0, 0, 0.2), -8px 8px 16px 0px rgba(0, 0, 0, 0.2)",
  },
}));

const OptaFloor = props => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);

  const classes = useStyles();
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>OptaFloor - Shop Floor Optimization Software | Jaza Software</title>
        <link rel="canonical" href={`${rootUrl}/optafloor`} />
        <meta
          name="description"
          content="Optimize performance, improve efficiency, and maximize profitability across the factory floor with an end to end solution."
        />
      </Helmet>

      <Parallax className={classes.parallax}>
        <div className={classes.container}>
          <GridContainer alignItems="center" justify="space-between" spacing={2}>
            <GridItem xs={12} sm={5} md={5} className={classes.content}>
              <div>
                <Typography variant="h5" className={classes.product}>
                  &gt; OptaFloor
                </Typography>
                <Typography variant="h4">Manufacturing Execution System (MES)</Typography>
              </div>
              <div className={classes.subtitle}>
                <Typography variant="subtitle1">
                  OptaFloor transforms data into actionable intelligence and can increase efficiency by up to 20%.
                </Typography>
              </div>
              <div style={{ marginTop: 32 }}>
                <Button
                  variant="contained"
                  className={clsx(classes.button, classes.buttonFilled)}
                  onClick={_ => props.history.push("/demo", { products: "OptaFloor" })}>
                  SCHEDULE A DEMO
                </Button>
              </div>
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Paper className={classes.videoContainer}>
                <Player
                  playsInline
                  src={`${pathMedia}/optimized_landing_video.mp4`}
                  fluid={true}
                  poster={`${pathMedia}/Dashboard-thumbnail.png`}>
                  <ControlBar autoHide={true} className="my-class" />
                  <LoadingSpinner />
                  <BigPlayButton position="center" />
                </Player>
              </Paper>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div className={classes.main}>
        <Clients />
        <Features />
        <DataFlow />
        <Blogs />
        {/* <FAQ /> */}
        <CallToAction
          title={
            <>
              <span>Shop Floor intelligence</span> <br /> <span>Your pathway to Industry 4.0</span>
            </>
          }
          subtitle="Book a free demo to learn how we can help you move towards Industry 4.0"
          actionLabel="Get in Touch"
          onClick={_ => props.history.push("/demo", { products: "OptaFloor" })}
          {...props}
        />
        {/* <CTA
          title={
            <>
              <span>Shop Floor intelligence</span> <br /> <span>Your pathway to Industry 4.0</span>
            </>
          }
          subtitle="Book a free demo to learn how we can help you enter the next phase of proactive manufacturing control."
          buttonLabel="Get in Touch"
          {...props}
        /> */}
        {/* {demoElement} */}
      </div>
    </div>
  );
};

export default OptaFloor;
